import PRODUCT_DOMAIN_TYPES from './ProductDomainTypes'
import BaseProduct, { IBaseProduct } from './BaseProduct'
import Product from './Product'
import { ProductReviewSummary } from '../ProductReview'
import { ProductVariantLite } from '../ProductVariant'
import { getFilteredImages } from './productLite.helper'
import productHelper, { CUSTOM_FIELD_NAMES } from '../../helpers/productHelper'

interface ProductBrandInfo {
  link?: string
  name?: string
}

export type IProductLite = IBaseProduct<ProductVariantLite> & {
  readonly productReviewSummary?: Pick<ProductReviewSummary, 'averageRating'> | undefined
  readonly productBrandInfo: ProductBrandInfo
}

export default class ProductLite extends BaseProduct<ProductVariantLite> implements IProductLite {
  readonly productReviewSummary?: Pick<ProductReviewSummary, 'averageRating'> | undefined
  readonly productBrandInfo: ProductBrandInfo
  readonly productDomainTypes = PRODUCT_DOMAIN_TYPES.PRODUCT_LITE

  constructor(iProductLite: IProductLite) {
    super(iProductLite, PRODUCT_DOMAIN_TYPES.PRODUCT_LITE)
    this.productReviewSummary = iProductLite.productReviewSummary
    this.productBrandInfo = iProductLite.productBrandInfo
    return {
      ...this,
    }
  }

  static fromProduct(product: Product) {
    const images = getFilteredImages(product)

    return new ProductLite({
      ...product,
      variants: (product.variants || []).map(variant => ProductVariantLite.fromProductVariant(variant)),
      images,
      productReviewSummary: product.productReviewSummary?.averageRating
        ? { averageRating: product.productReviewSummary.averageRating }
        : undefined,
      productBrandInfo: {
        link: productHelper.getCustomFieldValue<string>(product, CUSTOM_FIELD_NAMES.BRAND_LINK, true),
        name: productHelper.getCustomFieldValue<string>(product, CUSTOM_FIELD_NAMES.BRAND_NAME, true),
      },
    })
  }
}
